const reviews = [
  {
    id: 1,
    name: "Emmanuel Kumah",
    role: "host",
    location: "Accra Meet Up",
    text:
      "Pretty impressive!,Potbelly saved the day, meals were organized swiftly",
    img: "images/reviews_01.png",
  },
  {
    id: 2,
    name: "Robert Carlson",
    role: "Guest",
    location: "Lunch Time With Friends",
    text:
      "I don't remember the last time i enjoyed a perfect get-together, our event was very well organized",
    img: "images/reviews_02.png",
  },
  {
    id: 3,
    name: "Aesos Taylor",
    role: "host",
    location: "Potbelly People",
    text:
      "Potbelly took away all the stress i encounter yearly when planing our office end of year event. Everyone enjoyed themselves",
    img: "images/reviews_03.jpg",
  },
];

export default reviews;
